import React from "react";

import { InstagramEmbed } from "react-social-media-embed";


function SocialMediaPreview({
  url ,
  isClickable = false,
  ...props
}) {
  if(!url) return null;
  if (isClickable) {
    return (
      <div>
        <InstagramEmbed url={url} {...props} />
      </div>
    );
  }
  return (
    <div className="relative max-h-full overflow-y-auto">
      <div className="relative">
        <InstagramEmbed url={url} captioned {...props} />
        <div
          className="absolute top-0 left-0 w-full h-full z-10"
          style={{ pointerEvents: "auto" }}
        />
      </div>
    </div>
  );
}

export default SocialMediaPreview;
